import { render, staticRenderFns } from "./SelectorMenu.vue?vue&type=template&id=3ad15dfb&scoped=true"
import script from "./SelectorMenu.vue?vue&type=script&lang=js"
export * from "./SelectorMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad15dfb",
  null
  
)

export default component.exports